// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1stlN","emails":"CreateEditClinics_emails__2R5Ay","emailTagLabel":"CreateEditClinics_emailTagLabel__holWa"};